
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7283/api/',
    //Live
    //apiUrl: 'https://art-api.solegaze.com/api/',
    //DEV
    apiUrl: 'https://ira-api-dev.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

